import "../styles/Winner.css";
export default function Winner(props) {
    return <>
        <div className="ContainerWinner" >
        <h1>
            congratulation 🎉 
        </h1>
        <h1>
            Name is : { props.Massage } 📛 
        </h1>
        <h1>
            the Number is  : 
            { props.Tel } 📞 
        </h1> 
        </div>
    </>;
};